export default __webpack_public_path__ + "static/media/squares800.856a6d3e.jpg";